<!-- eslint-disable -->
<template lang="pug">
        cs-modal(@close="$emit('close')", :is-blur="true")
                div(v-if="!this.successfullyAdded")
                        .points-modal__header(slot="header")
                                | {{ $i18n.t('points.points_modal_pointsChanging') }}
                        form.points-modal__form(action="javascript://" @submit="updatePoints")
                                .points-modal__item.points-modal__text
                                        | {{ user.fullName }}
                                        | {{ pointsString }}
                                cs-input.points-modal__input(
                                        type="number"
                                        onkeydown="if (`${this.value}`.length >= 9 && event.keyCode !== 8) return false;"
                                        :placeholder="$i18n.t('points.points_modal_inputPlaceholder')"
                                        v-model.number="points"
                                        v-validate="'required|max:9'"
                                        v-focus="true"
                                        name="number"
                                        :data-vv-as="$i18n.t('points.points_modal_pointsCount')"
                                )
                                help-text(v-if="errors.has('number')" :error="errors.has('number')")
                                        | {{ errors.first('number') }}
                                .points-modal__item.points-modal__text--big
                                        | {{ $i18n.t('points.points_modal_total') }} {{ total }}
                                .points-modal__buttons
                                        router-link.points-modal__link(
                                                :to="routerObject"
                                        ) {{ $i18n.t('points.points_modal_pointsChangingHistory') }}
                                        cs-button.points-modal__button(
                                                color="blue"
                                                :loading="isLoading"
                                                :disabled="errors.has('number')"
                                                @click.prevent="updatePoints"
                                        ) {{ $i18n.t('points.points_modal_scorePoints') }}
                .points-modal__add-miles_container(v-else)
                        span
                                svg-icon.points-modal__add-miles_successfully-added(name="check", size="xx-large")
                        span.points-modal__add-miles_text
                                | {{ $i18n.t('points.points_modal_pointsWasAdd') }}
</template>

<script>
    /*eslint-disable*/
    import UserApi from '../api/user/user'

    import CsModal from '../elements/CsModal.vue'
    import HelpText from '../elements/HelpText.vue'

    import {mapState} from 'vuex'

    export default {
        props: {
            user: Object,
            access: String,
        },
        components: {
            CsModal,
		        HelpText
        },
        data () {
            return {
                isLoading: false,
                points: 0,
                successfullyAdded: false
            }
        },
        mounted() {
            this.$validator.validateAll();
        },
        methods: {
            updatePoints () {
                this.$validator.validateAll()
                .then(response => {
                    if (response && this.points) {
                        this.isLoading = true;
                        this.$emit('points', +this.points);
                        return UserApi.updatePoints(this.user.id, {points: this.points, pointsAccess: this.pointsAccess})
                    }
                })
                .then(() => {
                    this.isLoading = false;
                    if (this.authUser.type === 'teacher') {
                        this.$toasted.success(this.$i18n.t('points.points_modal_requestWasSend'));
                    } else if (this.points > 0) {
                        this.$toasted.success(this.$i18n.t('points.points_modal_pointsWasAdd'));
                    } else {
                        this.$toasted.success(this.$i18n.t('points.points_modal_pointsWasRemove'));
                    }
                    this.successfullyAdded = !this.successfullyAdded;
                    setTimeout(() => {this.$emit('close');}, 5000)
                })
                .catch(() => {
                    this.isLoading = false;
                })
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user
            }),
            pointsString () {
                let points = this.user[`${this.user.pointsAccesses[0]}Points`];
                return '(' + points + ' ' + this.$i18n.tc('points.points_modal_pointsDeclination', points) + ')';
            },
            total () {
                let points = this.points;
                points += this.user[`${this.user.pointsAccesses[0]}Points`];
                return points + ' ' + this.$i18n.tc('points.points_modal_pointsDeclination', points);
            },
            pointsAccess() {
                return this.access ? this.access : this.user.pointsAccesses[0]
            },
            routerObject () {
                return {
                    name: 'points-history',
                    params: {type: 'homework', pointsAccess: this.access},
                    query: {
                        schoolId: this.user.grades[0] && this.user.grades[0].schoolId,
                        gradeId: this.user.grades[0] && this.user.grades[0].id,
                        userId: this.user.id
                    }
                };
            },
        }
    }
</script>

<style lang="scss" scoped>
        .points-modal__header {
                font-size: 22px;
                font-weight: 500;
        }
		.points-modal__form {
				margin-top: 25px;
				text-align: left;
		}

		.points-modal__input {
				margin-top: 10px;
				&::-webkit-inner-spin-button,
				&::-webkit-outer-spin-button{
						appearance: none;
						margin: 0;
				}
		}

		.points-modal__item {
				margin-top: 10px;
		}

		.points-modal__text {
				font-weight: 500;
				font-size: 16px;
				line-height: 19px;
		}

		.points-modal__text--big {
				font-weight: 500;
				font-size: 18px;
				line-height: 21px;
		}

		.points-modal__buttons {
				margin-top: 15px;
				display: flex;
				flex-direction: column;
				@include media($md) {
						flex-direction: row;
						align-items: center;
						justify-content: space-between;
				}
		}

		.points-modal__link {
				color: $hsl-color-blue-56;
				text-decoration: underline;
				margin-bottom: 20px;
				@include media($md) {
						margin-bottom: 0;
				}
		}

		.points-modal__link:hover {
				color: $hsl-color-blue-56;
				text-decoration: none;
		}

		.points-modal__button {
				max-width: 200px;
				@include media($md) {
						max-width: none;
				}
		}
        .points-modal__add-miles_container {
                display: flex;
                flex-direction: column;
        }

        .points-modal__add-miles_successfully-added {
                border-radius: 50%;
                color: $hsl-color-green-58;
                border: 4px solid $hsl-color-green-58;
                padding: 8px;
                margin-bottom: 20px;
        }

        .points-modal__add-miles_text {
                font-size: 22px;
                font-weight: 500;
        }
</style>
